/* eslint-disable */

import intl from 'intl';
import React from 'react';
import { IntlProvider } from 'react-intl'; 
import * as ReactDOMClient from 'react-dom/client';
import PiwikReactRouter from 'piwik-react-router';

import { configureInterceptors } from './redux/axios-interceptors';
import history from './history';
import configureStore from './redux/configure-store';
import Root from './containers/Root';
import "core-js";

require('es6-promise').polyfill();
require('./static/includes-polyfill.js').polyfill();


if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill');
  require('@formatjs/intl-pluralrules/locale-data/en'); 
  require('@formatjs/intl-pluralrules/locale-data/es'); 
  require('@formatjs/intl-pluralrules/locale-data/fr'); 
  require('@formatjs/intl-pluralrules/locale-data/zh'); 
  require('@formatjs/intl-pluralrules/locale-data/de'); 
  require('@formatjs/intl-pluralrules/locale-data/fo'); 
  require('@formatjs/intl-pluralrules/locale-data/pt'); 
}

if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill');
  require('@formatjs/intl-relativetimeformat/locale-data/de'); 
  require('@formatjs/intl-relativetimeformat/locale-data/en'); 
  require('@formatjs/intl-relativetimeformat/locale-data/fr'); 
  require('@formatjs/intl-relativetimeformat/locale-data/es'); 
  require('@formatjs/intl-relativetimeformat/locale-data/zh'); 
  require('@formatjs/intl-relativetimeformat/locale-data/de'); 
  require('@formatjs/intl-relativetimeformat/locale-data/fo'); 
  require('@formatjs/intl-relativetimeformat/locale-data/pt'); 
}

const store = configureStore({});

configureInterceptors(store);

if (window.piwikConfig && window.piwikConfig.url && window.piwikConfig.siteId) {
  window.piwik = PiwikReactRouter({
    url: window.piwikConfig.url,
    siteId: window.piwikConfig.siteId,
    enableLinkTracking: false,
  });
}

function run() {
  ReactDOMClient.createRoot(document.getElementById('root')).render(<Root store={store} history={history} />)
}

// Check if polyfill required
if (!window.Intl) {
  // Webpack parses the inside of require.ensure at build time to know that intl
  // should be bundled separately.
  require.ensure([], () => {
    // Ensure only makes sure the module has been downloaded and parsed.
    intl();
    // Now we actually need to run it to install the polyfill.
    run();
  });
} else {
  run();
}
